import { Injectable } from '@angular/core';

import { AwningService } from './../../../../services/awning/awning.service';
import { DragHandlerBase } from './drag-handler-base';
import { CollisionService } from '../../../../services/collision/collision.service';
import { mountableObjectIsWithinWallArea } from '../../../../services/wall/utils/mountable-object-is-within-wall-area';
import { pipeFns } from '../../../../utils/pipe-fns';

declare const THREE: any;

class KeepAwningOnWallAreaHandler extends DragHandlerBase {
  protected matrix = new THREE.Matrix4();
  protected wallBox = new THREE.Box3();
  protected objectBox = new THREE.Box3();
  protected objectBoxCenter = new THREE.Vector3();
  protected objectBoxSize = new THREE.Vector3();
  protected _wallSize = new THREE.Vector3();
  protected _wallDirection = new THREE.Vector3();
  protected _position = new THREE.Vector3();

  constructor(
    nextHandler,
    private collisionSrvc: CollisionService,
    private awningService: AwningService
  ) {
    super(nextHandler);
  }

  move(e, transformation) {
    const draggedObject = e.draggedObject;
    const newSizes = this.awningService.getSizes(draggedObject);
    const baseCenterPosition = this.awningService.getCenter(draggedObject);
    const draggedObjPositionCorrectionShift = pipeFns(position =>
      position.sub(draggedObject.getWorldPosition(new THREE.Vector3()))
    )(baseCenterPosition.clone());
    const newBaseCenterPosition = pipeFns(position =>
      position.add(draggedObjPositionCorrectionShift)
    )(transformation.position.clone());
    const staticObjects = e.staticObjects.filter(
      so => !this.awningService.isFromTheSameGroup(draggedObject, so)
    );
    const singleObjectDrag = e.draggedObjects.length === 1;
    const collidedObject = this.collisionSrvc.isCollide(draggedObject, staticObjects, {
      newPosition: transformation.position,
      newSize: newSizes
    });

    if (singleObjectDrag && !collidedObject) {
      const wall = draggedObject.parent;

      // if an object is out of wall area,
      // do not apply transformation
      if (
        !mountableObjectIsWithinWallArea(
          wall,
          { width: newSizes.z, length: newSizes.x, height: newSizes.y },
          newBaseCenterPosition,
          draggedObject.rotation
        )
      ) {
        transformation.position = draggedObject.getWorldPosition(new THREE.Vector3());
      }
    }

    super.move(e, transformation);
  }
}

@Injectable()
export class KeepAwningOnWallBoundsHandlerFactory {
  constructor(private collisionService: CollisionService, private awningService: AwningService) {}

  create(nextHandler?: DragHandlerBase): DragHandlerBase {
    return new KeepAwningOnWallAreaHandler(null, this.collisionService, this.awningService);
  }
}



// WEBPACK FOOTER //
// ./src/app/Component(2D and 3D)/3D/Drag/Handler/keep-awning-on-wall-area-handler.ts